module.exports = __webpack_public_path__ + "img/profile.6060f4ae.jpg";